export default function AboutUs() {
  const stats = [
    { number: '20+', label: 'Years Experience' },
    { number: '500+', label: 'Projects Completed' },
    { number: '100%', label: 'Client Satisfaction' },
    { number: '24/7', label: 'Support Available' }
  ];

  const certifications = [
    { name: 'Control4 Certified', icon: 'ri-shield-check-line' },
    { name: 'Savant Authorized', icon: 'ri-award-line' },
    { name: 'RTI Dealer', icon: 'ri-medal-line' },
    { name: 'Licensed & Insured', icon: 'ri-verified-badge-line' }
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <p className="text-[11px] tracking-[0.3em] uppercase text-[#4A90E2] mb-4 font-light">
              ABOUT RDM SECURITY
            </p>
            <h2 className="text-5xl font-serif text-gray-900 mb-6 leading-tight">
              <strong>Florida's Premier</strong><br />
              Smart Home Experts
            </h2>
            <p className="text-base text-gray-600 leading-relaxed mb-6">
              Since 2004, <strong>RDM Security</strong> has been transforming luxury residences across <strong>South East Florida</strong> and <strong>West Coast Tampa South</strong> with cutting-edge <strong>home automation solutions</strong>.
            </p>
            <p className="text-base text-gray-600 leading-relaxed mb-8">
              Our team of certified technicians specializes in <strong>Control4, Savant, RTI, and Brilliant</strong> platforms, delivering seamless integration of lighting, climate, entertainment, security, and networking systems. We pride ourselves on exceptional craftsmanship, personalized service, and ongoing support.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6 mb-8">
              {stats.map((stat, index) => (
                <div key={index} className="text-center p-6 bg-gradient-to-br from-gray-50 to-white rounded-xl border border-gray-200">
                  <div className="text-4xl font-bold text-[#4A90E2] mb-2">
                    {stat.number}
                  </div>
                  <div className="text-sm text-gray-600">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            {/* Certifications */}
            <div className="grid grid-cols-2 gap-4">
              {certifications.map((cert, index) => (
                <div key={index} className="flex items-center gap-3 p-4 bg-[#4A90E2]/5 rounded-lg">
                  <div className="w-10 h-10 rounded-full bg-[#4A90E2]/10 flex items-center justify-center flex-shrink-0">
                    <i className={`${cert.icon} text-[#4A90E2] text-lg`}></i>
                  </div>
                  <span className="text-sm font-medium text-gray-900">{cert.name}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/d6877ad00d0964938554ff8e34be7da8.jpg"
                alt="RDM Security Professional Technician"
                title="Certified Home Automation Installation Florida"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>

            {/* Floating Badge */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl p-6 border border-gray-200">
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#4A90E2] to-[#357ABD] flex items-center justify-center">
                  <i className="ri-customer-service-2-line text-3xl text-white"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-900">24/7</div>
                  <div className="text-sm text-gray-600">Support</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
